<template>
    <div :class="{ offline: !isOnline, online: isOnline }">
        <slot :isOnline="isOnline"></slot>
        <button class="cs-btn secondary" v-if="!isOnline" @click="reloadPage">Reload</button>
    </div>
</template>

<script>
import { useUserStore } from '../../store/user.js';

const { VITE_apiUrl: apiUrl } = import.meta.env;

export default {
    data() {
        return {
            isOnline: true,
            pingUrl: apiUrl,
            interval: null,
            checkInterval: 15 * 60 * 1000,
            abortController: null
        };
    },
    setup() {
        const userStore = useUserStore();
        return { userStore };
    },
    methods: {
        async checkConnectivity() {
            // Skip check if paused (during file uploads, etc.)
            if (this.userStore.pauseConnectivityChecks) {
                return;
            }

            // Cancel any existing request
            if (this.abortController) {
                this.abortController.abort();
            }

            // Create new AbortController with timeout
            this.abortController = new AbortController();
            const timeoutId = setTimeout(() => {
                this.abortController.abort();
            }, 5000); // 5 second timeout

            try {
                const response = await fetch(this.pingUrl, {
                    cache: 'no-store',
                    signal: this.abortController.signal
                });
                clearTimeout(timeoutId);

                if (response.ok) {
                    this.isOnline = true;
                } else {
                    this.isOnline = false;
                }
            } catch (error) {
                clearTimeout(timeoutId);
                // Only set offline if it's not an abort error
                if (error.name !== 'AbortError') {
                    this.isOnline = false;
                }
            }
        },
        startChecking() {
            this.checkConnectivity(); // Initial check
            this.interval = setInterval(this.checkConnectivity, this.checkInterval);
        },
        stopChecking() {
            clearInterval(this.interval);
            if (this.abortController) {
                this.abortController.abort();
            }
        },
        reloadPage() {
            window.location.reload();
        }
    },
    mounted() {
        this.startChecking();
    },
    beforeDestroy() {
        this.stopChecking();
    }
};
</script>

<style scoped>
.offline[data-v-602b27cc] {
    background-color: var(--cs-error-600, #D92D20);
    display: flex;
    gap: 25px;
    padding: 10px;
    align-items: center;
    justify-content: center;
    color: var(--cs-white);
    font-size: 20px;
}

[data-theme="dark"] .offline[data-v-602b27cc] {
    background-color: var(--cs-error-700, #B91C1C);
}
</style>